import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { TabContextTitle } from '../components/tab-context-title';
import {
  FieldSelectCollector,
  FieldSelectWasteReceptionPoint,
  FormFieldIdocDlg,
} from 'shared-pages/components';
import { FieldSelectPackagingTypeCode } from '../components/fs-packaging-type-code';
import {
  FieldCheckBox,
  FieldDatepicker,
  FieldInput,
  FormCol,
  FormCol3,
  FormCol6,
  FormRow,
  promiseModalSelectDateOnly,
} from 'motion-components';
import { useFieldDisabledByStatus } from '../services';
import { isPackagingStepNeeded } from '../services/is-packaging-step-needed';
import CreateCollectionButton from 'shared-pages/pages/collection-orders/createCollectionButton';
import { CollectionOrderStates } from 'shared-pages/common/constants';
import { useRootStore } from 'store';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useActionFunctions } from '../action-buttons-approval-flow';

export const OrderCollectorTab = ({ data }) => {
  const { t } = useTranslation();
  const { values } = useFormikContext<{ collectorId?: number; xrbData?: any }>();
  const { appStore } = useRootStore();
  const fieldDisabled = useFieldDisabledByStatus();
  const packagingStepIsNeeded = isPackagingStepNeeded(data.xrbData);

  const { handleCollectorRescheduleCollection } = useActionFunctions();
  async function rescheduleCollection(): Promise<void> {
    const result = await promiseModalSelectDateOnly({
      title: 'Καθορίστε Νέα Ημερομηνία Συλλογής', // optional, αυτό είναι default
      text: 'Η Νέα Ημερομηνία Συλλογής θα χρησιμοποιηθεί για την επαναπρογραμματισμό της συλλογής.',
      init: { date: data?.plannedCollectionDate ?? new Date() }, // προαιρετική αρχική ημερομηνία
      acceptText: 'ΟΚ',
      denyText: 'ΑΚΥΡΩΣΗ',
    });
    if (result && result !== false) {
      const chosen = result.date as Date;
      console.log(chosen);
      await handleCollectorRescheduleCollection(chosen);
    }
  }

  return (
    <div>
      <TabContextTitle label={t('Συλλογή')} badge={packagingStepIsNeeded ? '4' : '3'} />
      <h5 className="form-group-title mt-3 mb-2">{t('Α. Ανάθεση σε Συλλέκτη')}</h5>
      <FormRow>
        <FieldSelectCollector
          as={FormCol}
          name="collectorId"
          label={t('Συλλέκτης')}
          disabled={fieldDisabled['collectorId']}
        />
      </FormRow>
      <FormRow>
        <FieldCheckBox
          as={FormCol6}
          name="xrbData.temperatureReadingRequired"
          label={t('Απαιτείται μέτρηση θερμοκρασίας κελύφους')}
          disabled={fieldDisabled['xrbData.temperatureReadingRequired']}
        />
      </FormRow>
      <FormRow>
        <FieldCheckBox
          as={FormCol6}
          name="xrbData.voltageReadingRequired"
          label={t('Απαιτείται μέτρηση υψηλής τάσης στους ακροδέκτες της συστοιχίας')}
          disabled={fieldDisabled['xrbData.voltageReadingRequired']}
        />
      </FormRow>
      <FormRow>
        <FieldInput
          as={FormCol3}
          name="xrbData.certifiedPackagingCode"
          label={t('Κωδικός πιστοποιημένης συσκευασίας')}
          disabled={true}
        />
        <FormCol3>
          {/* Τύπος Διαθέσιμης Συσκευασίας */}
          <FieldSelectPackagingTypeCode
            as={'div'}
            // Αν έχει τιμή => disabled
            disabled={
              !!values.xrbData?.packagingTypeCode
                ? true
                : fieldDisabled['xrbData.packagingTypeCode']
            }
          />
        </FormCol3>
        <FieldCheckBox
          as={FormCol3}
          name="xrbData.collordPackagingReturnRequired"
          label={t('Απαιτείται επιστροφή συσκευασίας')}
          // values.xrbData.appropriatePackaging === true => disabled
          disabled={
            values.xrbData?.appropriatePackaging === true
              ? true
              : fieldDisabled['xrbData.collordPackagingReturnRequired']
          }
        />
      </FormRow>
      <FormRow>
        <FieldSelectWasteReceptionPoint
          as={FormCol3}
          name="xrbData.wastereceptionpointId"
          label={t('Σημείο Παραλαβής Αποβλήτων')}
          // collectorId={values?.collectorId}
          disabled={fieldDisabled['xrbData.wastereceptionpointId']}
        />
      </FormRow>

      <h5 className="form-group-title mt-3 mb-2">{t('Β. Προγραμματισμός Συλλογής')}</h5>
      <FormRow className="mt-4">
        <FieldDatepicker
          as={FormCol3}
          label={t('Προγραμματισμένη Ημερομηνία Συλλογής')}
          name="plannedCollectionDate"
          disabled={fieldDisabled['plannedCollectionDate']}
        />
        <FormCol3>
          <Button
            variant="outline-primary"
            onClick={rescheduleCollection}
            disabled={fieldDisabled['re-plan-CollectionDate']}
          >
            Επαναπρογραμματισμός Συλλογής
          </Button>
        </FormCol3>
      </FormRow>

      <h5 className="form-group-title mt-3 mb-2">{t('Γ. Εκτέλεση Συλλογής')}</h5>

      <FormRow>
        {/* !data?.collection?.id && */}
        {data?.statusId === CollectionOrderStates.ScheduledCollectorCollection && (
          <FormCol className="col-md d-flex align-items-center justify-content-between mt-4">
            <CreateCollectionButton
              collectionOrderId={data?.id}
              injectData={{
                netWeight: data?.xrbData?.totalRequestWeight,
                qty: data?.xrbData?.orgPieceCount,
                wastereceptionpointId: data?.xrbData?.wastereceptionpointId,
                collectorId: data?.collectorId,
              }}
              disabled={
                !(
                  data?.statusId == CollectionOrderStates.ScheduledCollectorCollection &&
                  appStore.isCollector
                )
              }
            />
          </FormCol>
        )}

        <FormCol className="col-md">
          {data?.collection?.id && (
            <>
              <Link to={`/collection/${data?.collection?.id}`} className="d-block mb-1">
                {t('Συλλογή :')}
              </Link>
              <FieldInput
                name="collection.code"
                placeholder=""
                disabled={true}
                style={{ marginTop: '2px' }}
              />
            </>
          )}
        </FormCol>

        {data?.collection?.dateCollected && (
          <FormCol>
            <FieldDatepicker
              label={t('Ημερομηνία Συλλογής')}
              name="collection.dateCollected"
              disabled={true}
            />
          </FormCol>
        )}

        {data?.collection?.idocs[0] && (
          <FormFieldIdocDlg
            as={FormCol}
            label={t('Έντυπο Αναγνώρισης')}
            idFieldName="collection.idocs[0].id"
            nameFieldName="collection.idocs[0].identificationDocument"
            disabled={true}
          />
        )}
      </FormRow>
    </div>
  );
};
